var text = {
  color: 'gray.500',
  fontSize: 'md',
  fontFamily: 'body',
  lineHeight: 'base'
};
var text$1 = text;
export { text$1 as default };